import {
  SET_CALENDER_ITEMS,
  SET_CALENDER_ITEMS_FETCHING,
} from '../../actions/calenders'

type State = {
  calendarItems: Object[],
  isFetching: boolean,
}

const initialState: State = {
  calendarItems: [],
  isFetching: false,
}

type Action =
| SET_CALENDER_ITEMS
| SET_CALENDER_ITEMS_FETCHING

export default function calendersReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case SET_CALENDER_ITEMS: {
      const { calendarItems } = action.payload
      return {
        ...state,
        calendarItems,
        isFetching: false,
      }
    }
    case SET_CALENDER_ITEMS_FETCHING: {
      return {
        ...state,
        isFetching: action.payload,
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/calenders/index.js